module.exports = __webpack_public_path__ + "static/media/Gilgamesh.da1e3281.png";